import { Directive, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LdwRouterService } from '../route/ldw-router.service';
import { WebdokuService } from '../web-doku/webdoku.service';
import { RBCheck } from '@ldw/roesberg';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { LinkErrorDialogComponent } from '../shared/dialogs/link-error-dialog/link-error-dialog.component';

@Directive()
export class PermaBaseComponent implements OnInit {
  translate = inject(TranslateService);
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  protected routerService = inject(LdwRouterService);
  protected webDokuService = inject(WebdokuService);
  private dialog = inject(MatDialog);

  public isActive = false;
  public ldwLink = '';
  protected webDokuId = '';
  protected webDoku = '';
  protected node = '';
  protected doc = '';

  ngOnInit(): void {
    if (this.routerService.wasPermaLink) {
      this.routerService.navigateToWebDokuSelection();
      return;
    }
    this.routerService.wasPermaLink = true;

    this.isActive = true;
    this.ldwLink = window.location.href;
    this.webDoku = decodeURI(this.route.snapshot.queryParams['webdoku'] ?? '');
    this.node = decodeURI(this.route.snapshot.queryParams['node'] ?? '');
    this.doc = decodeURI(this.route.snapshot.queryParams['doc'] ?? '');

    if (RBCheck.isNullOrEmpty(this.webDoku)) {
      this.showError('LINK.WEBDOKUEMPTY', null);
      return;
    }

    this.webDokuService.getWebDokuByName$(this.webDoku).subscribe((wdId) => {
      if (RBCheck.isNullOrEmpty(wdId)) {
        this.showError('LINK.WEBDOKUNOTFOUND', null);
        return;
      }
      this.webDokuId = wdId;
      this.process();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected process() {}

  protected showError(text: string, action: any) {
    this.isActive = false;
    console.log(`can not resolve link for '${this.ldwLink}'`);
    console.log('error: ' + this.translate.instant(text));
    const errorDialog = this.dialog.open(LinkErrorDialogComponent, {
      data: {
        message: text,
        linktext: this.ldwLink,
      },
    });
    errorDialog.afterClosed().subscribe(() => {
      if (action == null) {
        this.routerService.navigateToWebDokuSelection();
      } else {
        action();
      }
    });
  }
}
